import App1 from '../views/Apps/App1.vue';
import App2 from '../views/Apps/App2.vue';

const appsRoutes = [   
    
    {
        path: '/Apps/App1',
        name: 'App1',
        component: App1,
        meta: { requiresAuth: true, permissions: ["app_1"] }, 
    },
    {
        path: '/Apps/App2',
        name: 'App2',
        component: App2,
        meta: { requiresAuth: true, permissions: ["app_2"] }, 
    },
];

export default appsRoutes;
